var _path, _path2, _polygon, _path3, _polygon2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5143722,2 L24.8290469,2 L24.8290469,39.0344308 L61.9849115,39.0344308 L61.9849115,11.6355868 C62,6.43327469 57.7337368,2 52.5143722,2 Z",
    fill: "#333745",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3267776,2 L11.6822995,2 C6.46293495,2 2,6.23724554 2,11.650666 L2,16.2799698 L16.3267776,16.2799698 L16.3267776,2 Z",
    fill: "#333745",
    fillRule: "nonzero"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#333745",
    fillRule: "nonzero",
    points: "2 24.9504901 16.3267776 24.9504901 16.3267776 39.2304599 2 39.2304599"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6732224,61.9849208 L52.3177005,61.9849208 C57.5370651,61.9849208 62,57.7476753 62,52.3342548 L62,47.7200302 L47.6732224,47.7200302 L47.6732224,61.9849208 Z",
    fill: "#333745",
    fillRule: "nonzero"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#333745",
    fillRule: "nonzero",
    points: "24.8290469 47.7200302 39.1558245 47.7200302 39.1558245 62 24.8290469 62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2,47.7200302 L2,52.349334 C2,57.5516461 6.25113464,62 11.6822995,62 L16.3267776,62 L16.3267776,47.7200302 L2,47.7200302 Z",
    fill: "#333745",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.859c9ab2487f13fd4ef67af59d07adc1.svg";
export { ForwardRef as ReactComponent };